var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[(_vm.item && _vm.component)?_c(_vm.component,_vm._b({tag:"component"},'component',{ item: _vm.item },false)):_vm._e(),(_vm.item && !_vm.component)?_c('div',[(_vm.props.length)?_c('simple-table',_vm._b({},'simple-table',_vm.infoTableProps,false)):_vm._e()],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }